'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.load = load;
exports.save = save;
exports.remove = remove;
exports.removeDocument = removeDocument;
exports.createDocument = createDocument;
exports.updateDocumentInfos = updateDocumentInfos;
exports.saveRequirements = saveRequirements;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'jai20enmaths-cms/chapter/LOAD';
var LOAD_SUCCESS = 'jai20enmaths-cms/chapter/LOAD_SUCCESS';
var LOAD_FAIL = 'jai20enmaths-cms/chapter/LOAD_FAIL';
var SAVE = 'jai20enmaths-cms/chapter/SAVE';
var SAVE_SUCCESS = 'jai20enmaths-cms/chapter/SAVE_SUCCESS';
var SAVE_FAIL = 'jai20enmaths-cms/chapter/SAVE_FAIL';

var initialState = {
  loaded: false,
  saving: false,
  saved: false,
  editing: {},
  saveError: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: action.result,
        error: null
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        data: null,
        error: action.error
      });
    case SAVE:
      return (0, _extends3.default)({}, state, {
        saving: true
      });
    case SAVE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        saving: false,
        saved: true,
        data: action.result,
        error: null
      });
    case SAVE_FAIL:
      return (0, _extends3.default)({}, state, {
        saving: false,
        saved: false,
        error: action.error
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  console.log('isLoaded', globalState.chapter && globalState.chapter.loaded);
  return globalState.chapter && globalState.chapter.loaded;
}

function load(chapterId) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/chapter/' + chapterId);
    } // params not used, just shown as demonstration
  };
}

function save(chapter) {
  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    promise: function promise(client) {
      return client.patch('/chapter/' + chapter._id, { data: chapter });
    }
  };
}

function remove(chapter) {
  console.log('remove');
  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    promise: function promise(client) {
      return client.del('/chapter/' + chapter._id);
    }
  };
}

function removeDocument(documentId) {
  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    promise: function promise(client) {
      return client.del('/document/' + documentId);
    }
  };
}

function createDocument(document) {
  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    promise: function promise(client) {
      return client.post('/document', { data: document });
    }
  };
}

function updateDocumentInfos(document) {
  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    promise: function promise(client) {
      return client.patch('/document/' + document._id + '/infos', { data: document });
    }
  };
}

function saveRequirements(chapterId, requirements) {
  return {
    types: [SAVE, SAVE_SUCCESS, SAVE_FAIL],
    promise: function promise(client) {
      return client.patch('/chapter/' + chapterId + '/requirements', { data: requirements });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/chapter.js
// module id = 124
// module chunks = 0